// extracted by mini-css-extract-plugin
export default {"groupList":"GroupColorKey_groupList__kytiw","count":"GroupColorKey_count__BoLYP"};